export enum ModalType {
  Unspecified = "unspecified",
  Add = "add",
  Edit = "edit",
  Display = "display",
  Delete = "delete",
  Change = "change",
}
